import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import FancyBlock from "../../components/crypto/FancyBlock";
import Promo from "../../components/promo/promo";
import VideoWithTextRow from "../../components/sustain-chain/video_with_text_row";

import SustainChainPartners from "../../components/sustain-chain/sustain_chain_partners";
import Meta from "../../components/Meta";

export default function SustainChain() {

  return (
    <>
      {/* <!-- Hero --> */}
      <Meta title="Impactoverse - Partners" />
      <section className="relative pt-24 pb-10">
        <div className="container">
          <div className="mx-auto mb-12 text-center">
            {/* Start global distribute and dao idea */}
            <div className="lg:flex lg:space-x-12">
              <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
                <Image
                  width={1519}
                  height={935}
                  src="/images/gradient.jpg"
                  alt="gradient"
                  className="h-full w-full object-cover"
                />
              </picture>
              <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
                <Image
                  width={1519}
                  height={935}
                  src="/images/gradient_dark.jpg"
                  alt="gradient dark"
                  className="h-full w-full object-cover"
                />
              </picture>
            </div>
            <div>
              {" "}
              <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
                Impactoverse is
                <br />
                <span className="animate-gradient">
                  pleased to partner with
                </span>
                <br />
              </h1>
              <div className="flex items-center justify-center mb-1 mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="500"
                  zoomAndPan="magnify"
                  viewBox="0 0 375 67.499998"
                  height="90"
                  preserveAspectRatio="xMidYMid meet"
                  version="1.0"
                  className="fill-accent/25 dark:fill-accent/50"
                >
                  <path
                    d="M 96.929688 18.601562 C 102.875 18.601562 106.9375 22.660156 106.9375 28.136719 L 101.460938 28.136719 C 101.460938 25.523438 99.792969 23.855469 96.929688 23.855469 C 94.066406 23.855469 92.398438 25.523438 92.398438 27.191406 C 92.398438 32.449219 107.878906 29.585938 107.878906 40.535156 C 107.878906 44.8125 103.601562 49.125 96.929688 49.125 C 90.257812 49.125 86.199219 45.03125 86.199219 39.300781 L 91.925781 39.300781 C 91.925781 41.910156 93.847656 43.832031 96.929688 43.832031 C 100.265625 43.832031 101.933594 42.164062 101.933594 40.242188 C 101.933594 34.769531 86.453125 37.632812 86.453125 27.191406 C 86.453125 22.660156 90.476562 18.601562 96.929688 18.601562 Z M 96.929688 18.601562 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 111.941406 39.808594 L 111.941406 26.9375 L 117.414062 26.9375 L 117.414062 39.082031 C 117.414062 41.949219 119.335938 43.832031 121.945312 43.832031 C 124.558594 43.832031 126.476562 41.910156 126.476562 39.082031 L 126.476562 26.9375 L 131.953125 26.9375 L 131.953125 48.835938 L 127.890625 48.835938 L 126.949219 46.699219 C 126.949219 46.699219 124.339844 49.089844 120.75 49.089844 C 115.492188 49.089844 111.941406 45.5 111.941406 39.808594 Z M 111.941406 39.808594 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 141.234375 41.949219 C 141.488281 43.363281 142.648438 44.558594 144.570312 44.558594 C 146.492188 44.558594 147.652344 43.363281 147.652344 42.164062 C 147.652344 39.082031 136.449219 40.96875 136.449219 33.355469 C 136.449219 29.765625 139.53125 26.683594 144.316406 26.683594 C 149.574219 26.683594 152.402344 29.550781 152.90625 33.355469 L 147.652344 33.355469 C 147.398438 32.414062 146.238281 31.214844 144.570312 31.214844 C 142.902344 31.214844 141.960938 32.160156 141.960938 33.355469 C 141.960938 36.4375 153.160156 34.550781 153.160156 42.417969 C 153.160156 46.007812 150.082031 49.089844 145.078125 49.089844 C 139.347656 49.089844 136.519531 46.226562 136.011719 41.949219 Z M 141.234375 41.949219 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 159.578125 21.679688 L 164.328125 21.679688 L 164.328125 26.9375 L 169.078125 26.9375 L 169.078125 31.941406 L 164.328125 31.941406 L 164.328125 41.003906 C 164.328125 42.925781 165.523438 44.085938 167.410156 44.085938 C 167.882812 44.125 168.390625 44.015625 168.824219 43.832031 L 168.824219 48.582031 C 167.988281 48.871094 167.082031 49.054688 166.214844 49.054688 C 161.9375 49.054688 158.816406 45.972656 158.816406 41.1875 L 158.816406 31.941406 L 155.480469 31.941406 L 155.480469 27.410156 L 156.894531 27.410156 C 158.5625 27.410156 159.507812 26.46875 159.507812 24.800781 Z M 159.578125 21.679688 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 171.941406 37.886719 C 171.941406 31.46875 176.691406 26.683594 182.164062 26.683594 C 184.449219 26.683594 186.660156 27.554688 188.367188 29.078125 L 189.308594 26.9375 L 193.367188 26.9375 L 193.367188 48.835938 L 189.308594 48.835938 L 188.367188 46.699219 C 186.660156 48.21875 184.449219 49.054688 182.164062 49.089844 C 176.726562 49.089844 171.941406 44.304688 171.941406 37.886719 Z M 182.890625 31.941406 C 179.808594 31.941406 177.417969 34.335938 177.417969 37.886719 C 177.417969 41.441406 179.808594 43.832031 182.890625 43.832031 C 185.972656 43.832031 188.367188 41.441406 188.367188 37.886719 C 188.367188 34.335938 186.007812 31.941406 182.890625 31.941406 Z M 182.890625 31.941406 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 198.371094 20.992188 C 198.40625 19.289062 199.785156 17.910156 201.488281 17.949219 C 203.15625 17.984375 204.535156 19.324219 204.535156 20.992188 C 204.570312 22.695312 203.195312 24.109375 201.488281 24.109375 C 199.785156 24.109375 198.371094 22.769531 198.371094 21.066406 C 198.371094 21.027344 198.371094 20.992188 198.371094 20.992188 Z M 204.101562 48.835938 L 198.625 48.835938 L 198.625 26.9375 L 204.101562 26.9375 Z M 204.101562 48.835938 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 229.332031 35.964844 L 229.332031 48.835938 L 223.859375 48.835938 L 223.859375 36.691406 C 223.859375 33.828125 221.9375 31.941406 219.328125 31.941406 C 216.714844 31.941406 214.796875 33.863281 214.796875 36.691406 L 214.796875 48.835938 L 209.320312 48.835938 L 209.320312 26.9375 L 213.382812 26.9375 L 214.324219 29.078125 C 214.324219 29.078125 216.933594 26.683594 220.523438 26.683594 C 225.78125 26.683594 229.332031 30.273438 229.332031 35.964844 Z M 229.332031 35.964844 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 247.679688 43.617188 C 251.085938 43.6875 254.132812 41.585938 255.292969 38.359375 L 261.273438 38.359375 C 259.824219 44.085938 254.820312 49.089844 247.679688 49.089844 C 239.8125 49.089844 233.140625 42.417969 233.140625 33.863281 C 233.140625 25.308594 239.8125 18.636719 247.679688 18.636719 C 254.601562 18.636719 259.570312 23.640625 261.019531 29.367188 L 255.074219 29.367188 C 254.347656 26.757812 251.738281 24.109375 247.679688 24.109375 C 242.929688 24.109375 238.867188 28.171875 238.867188 33.863281 C 238.867188 39.554688 242.929688 43.617188 247.679688 43.617188 Z M 247.679688 43.617188 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 285.09375 35.964844 L 285.09375 48.835938 L 279.617188 48.835938 L 279.617188 36.691406 C 279.617188 33.828125 277.699219 31.941406 275.085938 31.941406 C 272.476562 31.941406 270.554688 33.863281 270.554688 36.691406 L 270.554688 48.835938 L 265.082031 48.835938 L 265.082031 18.816406 L 270.554688 18.816406 L 270.554688 29.078125 C 270.554688 29.078125 272.476562 26.683594 276.753906 26.683594 C 281.503906 26.683594 285.09375 30.273438 285.09375 35.964844 Z M 285.09375 35.964844 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 288.898438 37.886719 C 288.898438 31.46875 293.648438 26.683594 299.125 26.683594 C 301.40625 26.683594 303.621094 27.554688 305.324219 29.078125 L 306.265625 26.9375 L 310.328125 26.9375 L 310.328125 48.835938 L 306.265625 48.835938 L 305.324219 46.699219 C 303.621094 48.21875 301.40625 49.054688 299.125 49.089844 C 293.648438 49.089844 288.898438 44.304688 288.898438 37.886719 Z M 299.847656 31.941406 C 296.765625 31.941406 294.375 34.335938 294.375 37.886719 C 294.375 41.441406 296.765625 43.832031 299.847656 43.832031 C 302.929688 43.832031 305.324219 41.441406 305.324219 37.886719 C 305.324219 34.335938 302.929688 31.941406 299.847656 31.941406 Z M 299.847656 31.941406 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 315.328125 20.992188 C 315.367188 19.289062 316.742188 17.910156 318.449219 17.949219 C 320.117188 17.984375 321.492188 19.324219 321.492188 20.992188 C 321.53125 22.695312 320.152344 24.109375 318.449219 24.109375 C 316.742188 24.109375 315.328125 22.769531 315.328125 21.066406 C 315.328125 21.027344 315.328125 20.992188 315.328125 20.992188 Z M 321.058594 48.835938 L 315.582031 48.835938 L 315.582031 26.9375 L 321.058594 26.9375 Z M 321.058594 48.835938 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 346.292969 35.964844 L 346.292969 48.835938 L 340.816406 48.835938 L 340.816406 36.691406 C 340.816406 33.828125 338.894531 31.941406 336.285156 31.941406 C 333.675781 31.941406 331.753906 33.863281 331.753906 36.691406 L 331.753906 48.835938 L 326.277344 48.835938 L 326.277344 26.9375 L 330.339844 26.9375 L 331.28125 29.078125 C 331.28125 29.078125 333.890625 26.683594 337.480469 26.683594 C 342.703125 26.683594 346.292969 30.273438 346.292969 35.964844 Z M 346.292969 35.964844 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 345.347656 21.101562 L 349.882812 21.101562 L 349.882812 22.480469 L 348.359375 22.480469 L 348.359375 26.539062 L 346.90625 26.539062 L 346.90625 22.515625 L 345.386719 22.515625 Z M 345.347656 21.101562 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 353.941406 26.574219 L 353.363281 26.574219 L 352.019531 23.785156 L 352.019531 26.574219 L 350.570312 26.574219 L 350.570312 21.101562 L 352.164062 21.101562 L 353.652344 24.183594 L 355.136719 21.101562 L 356.734375 21.101562 L 356.734375 26.574219 L 355.28125 26.574219 L 355.28125 23.785156 Z M 353.941406 26.574219 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 30.292969 18.527344 C 33.484375 17.800781 36.820312 18.09375 39.828125 19.359375 L 37.582031 24.726562 C 35.695312 23.929688 33.59375 23.75 31.5625 24.183594 Z M 30.292969 18.527344 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 22.0625 23.421875 C 24.238281 20.957031 27.140625 19.253906 30.332031 18.527344 L 31.597656 24.183594 C 29.605469 24.65625 27.757812 25.707031 26.414062 27.265625 Z M 22.0625 23.421875 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 18.183594 32.195312 C 18.511719 28.933594 19.851562 25.851562 22.027344 23.421875 L 26.378906 27.265625 C 25 28.789062 24.167969 30.746094 23.949219 32.777344 Z M 18.183594 32.195312 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 20.179688 41.585938 C 18.546875 38.757812 17.859375 35.457031 18.183594 32.195312 L 23.984375 32.777344 C 23.769531 34.84375 24.203125 36.910156 25.253906 38.683594 Z M 20.179688 41.585938 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 27.285156 48.039062 C 24.3125 46.660156 21.808594 44.414062 20.179688 41.585938 L 25.21875 38.683594 C 26.234375 40.460938 27.792969 41.910156 29.679688 42.746094 Z M 27.285156 48.039062 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 36.820312 49.164062 C 33.59375 49.816406 30.292969 49.417969 27.285156 48.074219 L 29.679688 42.78125 C 31.5625 43.617188 33.664062 43.871094 35.660156 43.472656 Z M 36.820312 49.164062 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 45.195312 44.449219 C 44.90625 44.777344 44.613281 45.066406 44.324219 45.320312 C 44.035156 45.574219 43.707031 45.863281 43.382812 46.117188 C 41.460938 47.640625 39.214844 48.65625 36.785156 49.125 L 35.660156 43.433594 C 36.675781 43.253906 37.617188 42.890625 38.523438 42.382812 C 38.960938 42.128906 39.394531 41.839844 39.792969 41.550781 C 40.011719 41.402344 40.191406 41.222656 40.375 41.042969 C 40.554688 40.859375 40.734375 40.714844 40.878906 40.496094 Z M 45.195312 44.449219 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 49.039062 35.855469 C 48.785156 37.34375 48.386719 38.832031 47.839844 40.242188 C 47.550781 41.003906 47.1875 41.765625 46.753906 42.457031 C 46.535156 42.816406 46.28125 43.144531 46.027344 43.507812 C 45.773438 43.832031 45.519531 44.195312 45.195312 44.484375 L 40.953125 40.535156 C 41.132812 40.351562 41.242188 40.171875 41.425781 39.992188 C 41.570312 39.808594 41.714844 39.589844 41.824219 39.410156 C 42.078125 38.976562 42.292969 38.539062 42.476562 38.070312 C 42.875 37.015625 43.164062 35.894531 43.347656 34.804688 Z M 49.039062 35.855469 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 50.851562 29.113281 C 50.34375 30.054688 49.945312 31.070312 49.691406 32.121094 C 49.617188 32.375 49.582031 32.667969 49.507812 32.921875 L 49.4375 33.320312 L 49.363281 33.828125 C 49.253906 34.480469 49.148438 35.167969 49.039062 35.855469 L 43.347656 34.804688 C 43.453125 34.191406 43.5625 33.574219 43.671875 32.921875 L 43.746094 32.449219 L 43.851562 31.871094 C 43.925781 31.46875 44 31.109375 44.105469 30.710938 C 44.46875 29.1875 45.050781 27.699219 45.8125 26.320312 Z M 50.851562 29.113281 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 55.203125 24.871094 C 54.292969 25.308594 53.460938 25.921875 52.734375 26.613281 C 52.011719 27.375 51.359375 28.207031 50.886719 29.113281 L 45.8125 26.320312 C 46.574219 24.910156 47.550781 23.640625 48.675781 22.480469 C 49.835938 21.320312 51.175781 20.375 52.664062 19.652344 Z M 55.203125 24.871094 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 61.109375 24.148438 C 60.601562 24.039062 60.09375 24 59.589844 23.964844 C 59.335938 23.964844 59.082031 23.964844 58.828125 23.964844 C 58.574219 23.964844 58.320312 24 58.066406 24.039062 C 57.050781 24.148438 56.109375 24.4375 55.203125 24.871094 L 52.664062 19.652344 C 54.148438 18.925781 55.746094 18.453125 57.375 18.273438 C 57.773438 18.199219 58.175781 18.199219 58.574219 18.164062 C 58.972656 18.128906 59.371094 18.128906 59.769531 18.164062 C 60.566406 18.199219 61.402344 18.273438 62.199219 18.417969 Z M 61.109375 24.148438 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 66.402344 27.011719 C 64.988281 25.523438 63.140625 24.507812 61.109375 24.109375 L 62.199219 18.417969 C 65.425781 19.035156 68.363281 20.628906 70.609375 23.023438 Z M 66.402344 27.011719 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 69.015625 32.449219 C 68.722656 30.417969 67.816406 28.496094 66.402344 27.011719 L 70.609375 23.023438 C 72.855469 25.414062 74.308594 28.425781 74.742188 31.6875 Z M 69.015625 32.449219 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 67.964844 38.394531 C 68.941406 36.582031 69.304688 34.480469 69.015625 32.449219 L 74.777344 31.6875 C 75.214844 34.949219 74.632812 38.25 73.109375 41.113281 Z M 67.964844 38.394531 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 63.648438 42.636719 C 65.496094 41.730469 67.019531 40.242188 67.964844 38.429688 L 73.074219 41.152344 C 71.550781 44.050781 69.125 46.371094 66.222656 47.820312 Z M 63.648438 42.636719 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 57.667969 43.507812 C 59.695312 43.832031 61.800781 43.542969 63.648438 42.601562 L 66.222656 47.785156 C 63.285156 49.234375 59.988281 49.742188 56.722656 49.199219 Z M 57.667969 43.507812 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M 52.300781 40.75 C 53.75 42.203125 55.636719 43.179688 57.667969 43.507812 L 56.722656 49.234375 C 53.496094 48.691406 50.523438 47.167969 48.203125 44.847656 Z M 52.300781 40.75 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                </svg>
              </div>
            </div>
            <p className="text-lg mb-10 dark:text-jacarta-300 text-center">
              Providing a public service platform purpose-built to unite the
              efforts of investors, innovators, government and non-profits to
              rebuild supply chains and make adequate progress toward reaching a
              sustainable future. Integrate, scale-up, find the critical
              resources and funding you need!
            </p>
            <Link
              href="https://www.sustainchain.world/groups/2061/accept?limit=25&offset=0&groupId=2061&isNotified=true"
              target="_blank"
              className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark uppercase"
            >
              LOGIN
            </Link>
          </div>
        </div>
      </section>

      {/* <!-- Page title --> */}
     
      {/* <!-- Intro / Statistics --> */}

      <section>
        <div className="container">
          {/* <!-- Video Lightbox --> */}
       
          <div className="py-10">
            {" "}
            <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
              About
              <span className="animate-gradient"> Sustainchain</span>
            </h1>
            <p className="text-lg mb-10 dark:text-jacarta-300 text-center">
              SustainChain™ is the world’s largest sustainability action
              platform that helps humanity collectively achieve the SDGs. As a
              public service platform, it brings together impact investors,
              innovators, purpose-driven brands, NGOs and alliances with a
              shared mission of building a more sustainable supply chain. Using
              artificial intelligence and machine learning, it maps global
              efforts across the sustainability ecosystem, providing actionable
              insights into hotspots to accelerate efficiency and speed.
            </p>
            <h3 className="block font-display text-xl font-medium group-hover:text-accent dark:text-white text-center uppercase">
            Let’s go farther, faster, together.
            </h3>
          </div>
        </div>
      </section>
           {/* <!-- YouTube Video Modal --> */}
      
      <VideoWithTextRow/>

   <Promo />

<SustainChainPartners/>
     

      
      {/* <!-- end hero -->  */}
    </>
  );
}
